import React from 'react';
import { Icon } from '@iconify/react';
import { Link } from 'react-router-dom';

interface AddURLResponseProps {
  response: {
    urlName?: string;
    label?: string;
  };
  label: string;
}

const AddURLResponse: React.FC<AddURLResponseProps> = ({ response }) => {
  return (
    <div className="flex items-center space-x-2"> 
      <div className='p-2 rounded bg-subprimary'>
        <Icon icon="mingcute:link-fill" className='text-textIcon' />
      </div>
      <Link to={response.urlName || '#'} target="_blank" rel="noopener noreferrer" className="main-label truncate max-w-[240px] overflow-hidden text-ellipsis text-sm hover:underline hover:text-darkBlue">
        {response.label || response.urlName}
      </Link>
  </div>
  );
};

export default AddURLResponse;
